/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Home page data (WP migration P4). ACF data (WP page 66) + carrier partners
 * (grouped by categoriesCarrierPartner) → local typed config. Images reference
 * the WP CDN for now (P5 media rehost).
 */
export const HOME: any = {
    /**
     * ‼ THE KEY IS `description`, NOT `metaDesc`.
     * It arrived from Yoast as `metaDesc` while `src/app/page.tsx` reads
     * `HOME.seo.description`, and `HOME` is typed `any` — so the mismatch
     * compiled, and THE HOME PAGE SHIPPED WITH NO META DESCRIPTION AT ALL.
     * Confirmed on live www.agentboost.com: zero `name="description"`. Every
     * sibling data file (products, about-us, contact-us, career) already uses
     * `description`; this was the only straggler.
     */
    seo: {
    "title": "Health Insurance FMO for Agents | Agent Boost Marketing",
    "description": "Join the FMO built by agents, for agents. Get top carrier contracts, quality leads, expert support, and free CRM tools to grow your Medicare, ACA & life business."
},
    banners: [
    {
        "title": "The Health Insurance FMO for Agents Serious about Growth",
        "subtitle": "Empowering agents with top contracts, expert support, and proven growth tools",
        "image": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/agentboost_agents.webp",
                "altText": ""
            }
        },
        "button": {
            "text": "Get Contracted",
            "url": "/get-contracted"
        }
    },
    {
        "title": "Get Your AHIP Certification",
        "subtitle": "Apply or renew your AHIP certification through Agent Boost Marketing and receive a $50 discount",
        "image": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/agentboost_agents_2.webp",
                "altText": ""
            }
        },
        "button": {
            "text": "Get AHIP Certified",
            "url": "https://www.agentboost.com/blog/about-ahip-certification"
        }
    },
    {
        "title": "Get Your AHIP Certification",
        "subtitle": "Apply or renew your AHIP certification through Agent Boost Marketing and receive a $50 discount",
        "image": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/agentboost_agents_3.webp",
                "altText": ""
            }
        },
        "button": {
            "text": "Get AHIP Certified",
            "url": "https://www.agentboost.com/blog/about-ahip-certification"
        }
    }
],
    sections: [
    {
        "title": "Who We Are",
        "bodyContent": "<p>We built the FMO we wish we had when we got started in the industry. Agent Boost Marketing is built by agents, for agents. We\u2019ve been in the industry for almost 20 years, we know the pain-points you face daily. That\u2019s why we provide the leads, training, and tools that takes the guesswork out of growth, so you can focus on selling and scaling your business. Everything we offer, from top carrier contracts to hands-on training, is designed to help you succeed faster, with fewer roadblocks. Come join a team of winners backed by the best health insurance FMO the industry has to offer.</p>\n",
        "orientation": "default",
        "mobileOrientation": "unset",
        "mode": "light",
        "image": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/who_we_are.webp",
                "altText": "who we are"
            }
        },
        "ctaText": null,
        "ctaLink": null
    },
    {
        "title": "Who We Help",
        "bodyContent": "<p><strong>We Help Agents Win\u2014No Matter Where You&#8217;re Starting From.</strong></p>\n<p>At Agent Boost Marketing, we help driven agents at every stage of their journey. From tech and training to leads and compliance, we give you everything you need to thrive. With the support of Agent Boost, you\u2019ll close more sales with confidence. If you\u2019re serious about success, you deserve a partner who\u2019s just as committed as you are.</p>\n",
        "orientation": "reverse",
        "mobileOrientation": "unset",
        "mode": "borderless",
        "image": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/who_we_help.webp",
                "altText": "we connect all around"
            }
        },
        "ctaText": null,
        "ctaLink": null
    },
    {
        "title": "Our Mission",
        "bodyContent": "<p><strong>This is your career. We\u2019re here to elevate it.</strong></p>\n<p>Agent Boost Marketing exists to empower agents to rise above the noise, grow with purpose, and lead with confidence. Our mission is to be the partner behind your success; committed, proven, and always in your corner. We built Agent Boost Marketing for agents who want more from their FMO, and aren\u2019t willing to settle.</p>\n<p>Partnering with Agent Boost Marketing means getting a partner in <em>your</em> success. Come find out why more agents than ever are choosing to partner with Agent Boost Marketing!</p>\n",
        "orientation": "default",
        "mobileOrientation": "unset",
        "mode": "dark",
        "image": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/our_mission.webp",
                "altText": "quality leads, ongoing support"
            }
        },
        "ctaText": null,
        "ctaLink": null
    }
],
    grid: {
    "title": "Why Partner With Agent Boost Marketing",
    "items": [
        {
            "title": "Regular Sales & Business Trainings",
            "body": "Agent Boost Marketing is invested in you. We want to see you succeed, so we'll teach you everything you need to know to constantly progress to that next level.",
            "image": {
                "node": {
                    "sourceUrl": "/assets/wp/2025/03/classroom.webp",
                    "altText": "classroom widget"
                }
            }
        },
        {
            "title": "Agent Training Center",
            "body": "Interactive modules to learn sales, administration and keep up with industry news and knowledge.",
            "image": {
                "node": {
                    "sourceUrl": "/assets/wp/2025/03/agent_training.webp",
                    "altText": "agent training widget"
                }
            }
        },
        {
            "title": "Quality Leads",
            "body": "We've solved the largest obstacle agents have; Leads! Our leads are vetted, either sponsored by carriers, generated ourself, or from trusted partners. This all means you get the highest quality leads possible!",
            "image": {
                "node": {
                    "sourceUrl": "/assets/wp/2025/03/training_and_development.webp",
                    "altText": "training and development"
                }
            }
        },
        {
            "title": "Data and Analytics",
            "body": "Commissions, book of business and performance tracking. See it all in one place for multiple carriers and lines of business.",
            "image": {
                "node": {
                    "sourceUrl": "/assets/wp/2025/03/chart.webp",
                    "altText": "chart widget"
                }
            }
        },
        {
            "title": "Rocket Sales CRM",
            "body": "Free access to the best CRM in the industry. Manage your pipeline all in one place. ",
            "image": {
                "node": {
                    "sourceUrl": "/assets/wp/2025/03/sales_crm.webp",
                    "altText": "sales crm widget"
                }
            }
        },
        {
            "title": "Game-Changing Technology",
            "body": "Compare plans, quote, and enroll your clients all in one place! Get access to HealthSherpa and Sunfire to compliantly enroll clients in-person, online, and over the phone.",
            "image": {
                "node": {
                    "sourceUrl": "/assets/wp/2025/03/e_app_center.webp",
                    "altText": "e app center widget"
                }
            }
        },
        {
            "title": "Expert Agent Support",
            "body": "Along with trainings, you'll have access to an Agent Success Manager, a dedicated resource to helping you achieve your sales goals!",
            "image": {
                "node": {
                    "sourceUrl": "/assets/wp/2025/03/agent_support.webp",
                    "altText": "agent support widget"
                }
            }
        },
        {
            "title": "Client Relations & Retention",
            "body": "Commissions, book of business and performance tracking. See it all in one place for multiple carriers and lines of business.",
            "image": {
                "node": {
                    "sourceUrl": "/assets/wp/2025/03/relationships.webp",
                    "altText": "agent relations widget"
                }
            }
        }
    ]
},
    carriers: { title: "Carrier Partners", items: [
    {
        "title": "Why Sell Aetna Medicare Advantage?",
        "slug": "aetna",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/aetnalogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Cigna HealthSpring?",
        "slug": "cigna-healthspring",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/healthspringcignalogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                },
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Humana?",
        "slug": "humana",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/humanalogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Allstate?",
        "slug": "allstate-health-solutions",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/allstate.webp",
                "altText": "allstate health solutions"
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                }
            ]
        }
    },
    {
        "title": "Why Sell Ambetter?",
        "slug": "ambetter-health",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/ambetter.webp",
                "altText": "ambetter health"
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                }
            ]
        }
    },
    {
        "title": "Why Sell Molina Healthcare?",
        "slug": "molina-healthcare",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/molinalogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                },
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Select Health?",
        "slug": "select-health",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/selecthealthlogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                },
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell United Healthcare?",
        "slug": "united-healthcare",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/image-removebg-preview-6.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                },
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Wellcare?",
        "slug": "wellcare",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/wellcarelogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Anthem?",
        "slug": "anthem",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/anthemlogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                },
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Zing Health?",
        "slug": "zing-health",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/zinghealthlogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Blue Cross Blue Shield of New Mexico?",
        "slug": "blue-cross-blue-shield-of-new-mexico",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/bcbsnmlgo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                }
            ]
        }
    },
    {
        "title": "Why Sell Blue Cross Blue Shield of Arizona?",
        "slug": "blue-cross-blue-shield-of-arizona",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/bluecross.webp",
                "altText": "bluecross"
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                }
            ]
        }
    },
    {
        "title": "Why Sell Blue Cross Blue Shield of Montana?",
        "slug": "blue-cross-blue-shield-of-montana",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/blueshield.webp",
                "altText": "blueshield"
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell United HealthCare Golden Rule?",
        "slug": "united-healthcare-golden-rule-insurance-co",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/image-removebg-preview-7.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Life & Ancillary"
                }
            ]
        }
    },
    {
        "title": "Why Sell Cigna Healthcare?",
        "slug": "cigna-healthcare",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/cigna.webp",
                "altText": "cigna"
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Aetna CVS Health?",
        "slug": "aetna-cvs-health",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/03/cvs.webp",
                "altText": "cvs"
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Life & Ancillary"
                }
            ]
        }
    },
    {
        "title": "Why Sell Florida Blue?",
        "slug": "florida-blue",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/bcbsfllogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Blue Cross Blue Shield of North Carolina?",
        "slug": "blue-cross-blue-shield-of-north-carolina",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/bcbsnclogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Devoted Health?",
        "slug": "devoted-health",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/devotedhealthlogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Medicare"
                }
            ]
        }
    },
    {
        "title": "Why Sell Wellpoint?",
        "slug": "wellpoint",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/wellpointlogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                }
            ]
        }
    },
    {
        "title": "Why Sell Blue Cross Blue Shield of Texas?",
        "slug": "blue-cross-blue-shield-of-texas",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/bcbstxlogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                }
            ]
        }
    },
    {
        "title": "Why Sell Blue Cross Blue Shield of Oklahoma?",
        "slug": "blue-cross-blue-shield-of-oklahoma",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/bcbsoklogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                }
            ]
        }
    },
    {
        "title": "Why Sell Kaiser Permanente?",
        "slug": "kaiser-permanente",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/kaiserlogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                }
            ]
        }
    },
    {
        "title": "Oscar",
        "slug": "oscar",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/oscarlogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                }
            ]
        }
    },
    {
        "title": "University of Utah Health",
        "slug": "university-of-utah-health",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/uofylogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "ACA"
                }
            ]
        }
    },
    {
        "title": "Great Western Insurance Company",
        "slug": "great-western-insurance-company",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/greatwesternlogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Life & Ancillary"
                }
            ]
        }
    },
    {
        "title": "Manhattan Life",
        "slug": "manhattan-life",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/Manhattanlifelogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Life & Ancillary"
                }
            ]
        }
    },
    {
        "title": "NCD",
        "slug": "ncd",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/NCDdentallogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Life & Ancillary"
                }
            ]
        }
    },
    {
        "title": "Wellabe",
        "slug": "wellabe",
        "featuredImage": {
            "node": {
                "sourceUrl": "/assets/wp/2025/04/Wellabelogo.webp",
                "altText": ""
            }
        },
        "categories": {
            "nodes": [
                {
                    "name": "Life & Ancillary"
                }
            ]
        }
    }
] },
    form: {
    "sectionTitle": "Get Contracted",
    "formTitle": "Get contracted with Agent boost Marketing",
    "sideImage": {
        "node": {
            "sourceUrl": "/assets/wp/2025/03/rocket_launch.webp",
            "altText": "rockey_launch"
        }
    },
    "ctaLabel": "Continue",
    "ctaLink": "/get-contracted",
    "terms": "<p>I agree to <a href=\"/terms-and-conditions\">terms &amp; conditions</a> provided by Agent Boost Marketing. By providing my phone number and email, I agree to receive text messages and emails from Agent Boost Marketing.</p>\n",
    "fields": [
        {
            "type": [
                "text"
            ],
            "label": "First Name",
            "name": "first_name",
            "placeholder": "First Name",
            "required": true,
            "colSpan": 1,
            "options": null
        },
        {
            "type": [
                "text"
            ],
            "label": "Last Name",
            "name": "last_name",
            "placeholder": "Last Name",
            "required": true,
            "colSpan": 1,
            "options": null
        },
        {
            "type": [
                "email"
            ],
            "label": "Email",
            "name": "email",
            "placeholder": "Your Email",
            "required": true,
            "colSpan": 2,
            "options": null
        },
        {
            "type": [
                "phone"
            ],
            "label": "Phone",
            "name": "phone",
            "placeholder": "Your Phone",
            "required": true,
            "colSpan": 2,
            "options": null
        },
        {
            "type": [
                "state"
            ],
            "label": "Resident State",
            "name": "resident_state",
            "placeholder": "Your Resident State",
            "required": true,
            "colSpan": 2,
            "options": null
        },
        {
            "type": [
                "text"
            ],
            "label": "National Producer Number (NPN)",
            "name": "national_producer_number",
            "placeholder": "Your national producer number (NPN)",
            "required": true,
            "colSpan": 2,
            "options": null
        },
        {
            "type": [
                "terms_checkbox"
            ],
            "label": "I agree to terms & conditions provided by Agent Boost Marketing. By providing my phone number and email, I agree to receive text messages and emails from Agent Boost Marketing.",
            "name": "termsConfirmed",
            "placeholder": null,
            "required": true,
            "colSpan": 2,
            "options": null
        }
    ]
},
    video: {
    "disableBg": false,
    "ctaLabel": "Our Media",
    "ctaLink": "/media",
    "panels": [
        {
            "title": "About Us",
            "videoUrl": "https://www.youtube.com/watch?v=QKVWqkRzYys"
        },
        {
            "title": "Our Team Leads",
            "videoUrl": "https://www.youtube.com/watch?v=ck2xMVDqwkU"
        },
        {
            "title": "Agent Success Stories",
            "videoUrl": "https://www.youtube.com/watch?v=7BtK_3jEnUM"
        },
        {
            "title": "Tech Tools & Support",
            "videoUrl": "https://www.youtube.com/watch?v=JtBV1sdOZUo"
        }
    ]
},
    testimonials: {
    "title": "What are our agents saying",
    "items": [
        {
            "content": "Agent Boost has been super helpful and supportive in getting all setup and ready to start selling. Their system works really good and they are always trying to make it a better experience for clients and employees.",
            "rating": 4.5,
            "datecreated": "2025-03-12T00:00:00+00:00",
            "client": {
                "name": "Miranda Cross",
                "image": {
                    "node": {
                        "sourceUrl": "/assets/wp/2025/04/lady-testimonial.webp",
                        "altText": "female testimonial"
                    }
                }
            }
        },
        {
            "content": "I have been working with Agent Boost Marketing for the past year now for both their Medicare and Affordable Care Act team, and they have been outstanding to me. From the agents to management to owners, everybody.",
            "rating": 4,
            "datecreated": "2025-04-03T00:00:00+00:00",
            "client": {
                "name": "David Lewis",
                "image": {
                    "node": {
                        "sourceUrl": "/assets/wp/2025/04/male-testimonial.webp",
                        "altText": "male testimonial"
                    }
                }
            }
        }
    ]
},
};
